import React from 'react'
import MessagesListPaginated from '../list-paginated'
import OutboxMessage from './message'
import useMessages from '../../../hooks/use-messages-paginated'

const OutboxMessageList = () => {
    const {
        isLoading,
        messages,
        total,
        offset,
        setOffset
    } = useMessages({
        box: 'out'
    })
    return (
        <MessagesListPaginated
            offset={offset}
            onOffsetChange={setOffset}
            messages={messages}
            total={total}
            messageComponent={OutboxMessage}
            isLoading={isLoading}
        />
    )
}

export default OutboxMessageList